import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import { UPLOAD, QUERY, GET, EXPORT } from '@hobs/constants/locations';

export function uploadLocations(body) {
  return dispatch => {
    dispatch(request());

    return fetchSecure('Location/Upload', {
      body: body,
      method: 'POST',
      multipart: true
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success());
          return { success: true, blob: response };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: response.payload
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: UPLOAD.REQUEST };
  }
  function success() {
    return { type: UPLOAD.SUCCESS };
  }
  function failure(error) {
    return { type: UPLOAD.FAILURE, error };
  }
}

export function queryLocations(query, exerciseId = null) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(`Exercise/Locations/${query}/${exerciseId}`, {
      cancel: true
    })
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: JSON.parse(response.response)
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: QUERY.REQUEST };
  }
  function success(payload) {
    return { type: QUERY.SUCCESS, query: payload };
  }
  function failure(error) {
    return { type: QUERY.FAILURE, error };
  }
}

export function getLocation(locationId) {
  return dispatch => {
    dispatch(request());

    return fetchSecure(`Location/${locationId}`)
      .then(response => {
        if (response.status === 200) {
          dispatch(success(response.payload));

          return { success: true, payload: response.payload };
        } else {
          dispatch(failure(response.toString()));
          const data = {
            status: response.status,
            payload: JSON.parse(response.response)
          };
          return { success: false, ...data };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: GET.REQUEST };
  }
  function success(payload) {
    return { type: GET.SUCCESS, location: payload };
  }
  function failure(error) {
    return { type: GET.FAILURE, error };
  }
}

export function exportLocationsExcel() {
  return dispatch => {
    dispatch(request());
    return fetchSecure('Locations/Excel', { forceBlob: true })
      .then(response => {
        if (response) {
          dispatch(success());
          return { success: true, blob: response };
        } else {
          dispatch(failure(response.toString()));
          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request() {
    return { type: EXPORT.REQUEST };
  }
  function success() {
    return { type: EXPORT.SUCCESS };
  }
  function failure(error) {
    return { type: EXPORT.FAILURE, error };
  }
}
